import $ from 'jquery';
import 'slick-carousel';
import MicroModal from 'micromodal';
import { TagManager } from '@dealersites/tag-manager/tag-manager';

import '../components/payment-calc/payment-calculations';
import PaymentCalculatorForm from '../components/payment-calc/payment-calculator';
import { LocalGarage } from '../components/garage/local';

MicroModal.init();




$('.masonry-item')
  .each(function () {
    const $item = $(this);
    const srcUrl = $item.data('url');

    const galleryImage = new Image();

    galleryImage.onload = () => {
      $item.find('.js-vdp-gallery-item').removeClass('opacity-0');
      $item.removeClass(
        ' bg-[url(/content/themes/ford-oem-theme/assets/icons/custom/vdp-ford-placeholder-anim.svg)]'
      );
    };

    galleryImage.onerror = () => {};
    galleryImage.src = srcUrl;
  })
  .on('hover', function (e) {
    e.stopPropagation();
  });

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if (urlParams.get('click')) {
  $(`.${urlParams.get('click')}`).trigger('click');
}

// Gallery
const galleryID = 'vdp-gallery-slider';
const $vdpGallerySlider = $(`.${galleryID}`);
const totalSlides = $vdpGallerySlider.data('total');
const $vdpGalleryPreviewSlider = $(`.${galleryID}-for`);

$vdpGallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $(`.controls-dots-${galleryID}`).data('theme');
    dots.addClass('slick-dot ' + theme);
  }
});

$vdpGallerySlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  speed: 200,
  touchThreshold: 100,
  asNavFor: `.${galleryID}-for`,
  appendDots: $(`.controls-dots-${galleryID}`),
  nextArrow: $(`.controls-next-${galleryID}`),
  prevArrow: $(`.controls-prev-${galleryID}`),
});

$vdpGalleryPreviewSlider.slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: `.${galleryID}`,
  focusOnSelect: true,
  centerMode: true,
  dots: false,
  speed: 200,
  touchThreshold: 100,
  infinite: true,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5,
        dots: false,
        centerMode: true,
        infinite: true,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 3,
        dots: false,
        centerMode: true,
        infinite: true,
      },
    },
  ],
});


// Gallery Carousel
$('.vdp-gallery-open').on('click', function () {
  MicroModal.show('modal-vdp-gallery');
  $vdpGallerySlider.slick('setPosition');
  $vdpGalleryPreviewSlider.slick('setPosition');
  $vdpGallerySlider.removeClass('opacity-0');
});

$('.js-vdp-gallery-item').on('click', function () {
  const item = $(this).data('index');
  $vdpGallerySlider.slick('slickGoTo', item);
  $vdpGalleryPreviewSlider.slick('slickGoTo', item);
  setTimeout(() => {
    MicroModal.show('modal-vdp-gallery');
    $vdpGallerySlider.slick('setPosition');
    $vdpGalleryPreviewSlider.slick('setPosition');
  }, 500);
});

// VDP CTAS (Left)

const $vdpCTASlider = $('.vdp-ctas-slider');
const $vdpCurrentCTASlide = $('.vdp-ctas-slider-current-item');

$vdpCTASlider.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  dots: false,
  nextArrow: $('.slide-m-next-vdp-ctas-slider'),
  prevArrow: $('.slide-m-prev-vdp-ctas-slider'),

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$vdpCTASlider.on('init reInit afterChange beforeChange', function (event, slick, currentSlide) {
  if (slick.slideCount > 1) {
    const current = (currentSlide ? currentSlide : 0) + 1;
    $vdpCurrentCTASlide.text(current + '/' + slick.slideCount);
  }
});

// Window sticker button (Right)
if (dsp.windowSticker) {
  $('a[data-window-sticker-id]').each(async function() {
    const $link = $(this);
    const itemId = $link.data('window-sticker-id');

    $link.removeAttr('data-window-sticker-id');

    try {
      const { window_sticker_url } = await dsp.windowSticker.fetch(itemId);
      $link.attr('href', window_sticker_url);
    } catch (e) {
      console.error("Could not update window sticker URL", e);
    }
  });
}

// Similar Vehicles SLIDER

const $vdpSimilarSlider = $('.vdp-similar-slider');
const $vdpCurrentSimilarSlide = $('.vdp-similar-slider-current-item');

$vdpSimilarSlider.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: false,
  nextArrow: $('.slide-m-next-vdp-similar-slider'),
  prevArrow: $('.slide-m-prev-vdp-similar-slider'),

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$vdpSimilarSlider.on('init reInit afterChange beforeChange', function (event, slick, currentSlide) {
  const current = (currentSlide ? currentSlide : 0) + 1;
  $vdpCurrentSimilarSlide.text(current + '/' + slick.slideCount);
});

// Garage related

const $garageCheckbox = $('.js-vdp-garage .compare-checkbox');
$garageCheckbox.on('change', function () {
  if ($(this).prop('checked')) {
    const model = $(this).data('model');
    const year = $(this).data('year');
    const status = $(this).data('status');

    const config = {
      onclick: {
        onclick: status + ':si:vehicle details:save',
        onclickLinkName: 'dc:' + status + ':si:vehicle details:content:action:save',
      },
    };

    if (year || model) {
      config.vehicle = {};
    }

    if (year) {
      config.vehicle.modelYear = year;
    }

    if (model) {
      config.vehicle.nameplate = model;
    }

    TagManager.trackEvent('global-onclick', config);
  }
});

function initGarageButton() {
  const itemId = $('[data-garage-toggle-id]').data('garageToggleId');
  const isInGarage = LocalGarage.has(itemId);
  syncGarageButton(isInGarage);
}

function syncGarageButton(isInGarage) {
  const $garageRemoveText = $('.js-garage-remove');
  const $garageAddText = $('.js-garage-add');

  if (isInGarage) {
    $garageRemoveText.removeClass('hidden');
    $garageAddText.addClass('hidden');
  } else {
    $garageRemoveText.addClass('hidden');
    $garageAddText.removeClass('hidden');
  }
}

$('[data-garage-toggle-id]').on('change', function () {
  const isInGarage = $(this).prop('checked');
  syncGarageButton(isInGarage);
});

initGarageButton();

// Async payment widget
const $asyncWidget = $('.js-payments-async');
if ($asyncWidget.length) {
  const itemId = $asyncWidget.data('item-id');
  fetch('/widget/payment?item_id=' + itemId)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      // Widget renders nothing when no rule covers this year — drop the skeleton.
      if (!html.trim()) {
        $asyncWidget.remove();
        return;
      }

      $asyncWidget.html(html).removeClass('js-payments-async');

      new PaymentCalculatorForm('js-calc-small-', ['vdp']);

      // payment-calculations.js binds these at module load time before async content exists
      const $financeBtn = $asyncWidget.find('#show-finance-info');
      const $leaseBtn   = $asyncWidget.find('#show-lease-info');

      $financeBtn.on('click', function () {
        $asyncWidget.find('.finance-lease-button').removeClass('active');
        // Mirror the lease handler: clear every lease block, terms and payment
        // pane alike, rather than relying on both carrying .calculator-info.
        $asyncWidget.find('.lease-info').removeClass('show');
        $financeBtn.addClass('active');
        $asyncWidget.find('.finance-info').addClass('show');
      });

      $leaseBtn.on('click', function () {
        $asyncWidget.find('.finance-lease-button').removeClass('active');
        $asyncWidget.find('.finance-info').removeClass('show');
        $leaseBtn.addClass('active');
        $asyncWidget.find('.lease-info').addClass('show');
      });

      const $customFormShow = $asyncWidget.find('.js-custom-form-show');
      if ($customFormShow.length) {
        const $payments = $asyncWidget.find('.vdp-payment-calc-form .vdp-payment-calc-tab-content');
        // Form is rendered synchronously as a sibling — look in the parent container
        const $customFormVisibility = $asyncWidget.parent().find('.js-submit-form-visibility');
        const formID = $customFormVisibility.data('form-id');

        $payments.addClass('inactive');

        $customFormShow.on('click', function () {
          $customFormVisibility.removeClass('inactive');
          $(this).addClass('inactive');
        });

        $(document).on('gform_confirmation_loaded', function (event, formId) {
          if (formId == formID) {
            $payments.removeClass('inactive');
          }
        });
      }
    });
}
